import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** 僅 DRAFT；刪除草稿。 */
export async function cancelStockTransfer(id) {
  const { data: raw } = await request.delete(`/ims/stock-transfer/${id}`);
  return parseVer4DetailResponse(raw);
}
